import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Subscription } from '../../domain/dtos/subscription'
import { QueryKey } from '../../domain/enums/query-key'
import { SubscriptionStatus } from '../../domain/enums/subscription-status'
import { DisableSubscriptionAutorenew } from '../../usecases/disable-subscription-autorenew'

export const useDisableAutorenew = () => {
  const container = useContainer()
  const queryClient = useQueryClient()

  return useMutation(
    [QueryKey.disableSubscriptionAutorenew],
    (id: string) => new DisableSubscriptionAutorenew(container.get(HttpClient)).execute(id),
    {
      retry: false,
      onSuccess: async (_, id) => {
        queryClient.setQueryData<Subscription | undefined>([QueryKey.getSubscription, id], (old) => {
          if (old) {
            return {
              ...old,
              autoRenew: false,
              status: SubscriptionStatus.CANCELED,
            }
          }
          return old
        })
      },
    },
  )
}
